import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import { services } from "@/mocks/homeData";
import JsonLD from "@/components/base/JsonLD";
import { offerSchema } from "@/components/base/PageSchemas";
import Breadcrumb from "@/components/base/Breadcrumb";

export default function OfferPage() {
  return (
    <div className="min-h-screen bg-background-50">
      <JsonLD data={offerSchema} />
      <Navbar />

      <main>
        <section className="pt-24 md:pt-32 pb-10 md:pb-14 bg-background-50">
          <div className="mx-auto max-w-[1440px] px-4 text-center md:px-8 lg:px-16 xl:px-20">
            <Breadcrumb />
            <span className="text-xs font-semibold tracking-[0.2em] uppercase text-accent-500 mb-3 block">Oferta</span>
            <h1 className="mx-auto max-w-3xl font-heading text-3xl text-foreground-950 md:text-4xl lg:text-5xl">
              Kompleksowa analiza kredytowa dla osób prywatnych
            </h1>
          </div>
        </section>

        <section className="pb-16 md:pb-24">
          <div className="mx-auto max-w-[1440px] px-4 md:px-8 lg:px-16 xl:px-20">
            <div className="mx-auto grid max-w-[1200px] grid-cols-1 gap-6 md:grid-cols-2 md:gap-8">
              {services.filter((s) => s.title !== "Kredyty firmowe" && s.title !== "Analiza finansowa").map((service) => (
                <div key={service.title} className="bg-white rounded-2xl p-6 md:p-8 border border-background-200/60">
                  <div className="w-14 h-14 flex items-center justify-center rounded-2xl bg-accent-100 mb-5">
                    <i className={`${service.icon} text-2xl text-accent-500`} />
                  </div>
                  <h2 className="font-heading text-lg font-semibold text-foreground-950 mb-3">{service.title}</h2>
                  <p className="text-sm text-foreground-600 leading-relaxed">{service.description}</p>
                </div>
              ))}

              <div className="bg-white rounded-2xl p-6 md:p-8 border border-background-200/60 md:col-span-2">
                <div className="w-14 h-14 flex items-center justify-center rounded-2xl bg-accent-100 mb-5">
                  <i className="ri-hand-heart-line text-2xl text-accent-500" />
                </div>
                <h2 className="font-heading text-lg font-semibold text-foreground-950 mb-3">Analiza finansowa</h2>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  Kompleksowa analiza sytuacji finansowej, planowanie budżetu, optymalizacja zobowiązań i bezpieczne podejście do zadłużenia. Pomagam zrozumieć pełny obraz finansowy i podjąć świadome decyzje.
                </p>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}
